import AllowlistEntriesView from "@/systems/modules/allowlist/AllowlistEntriesView.vue";
import AllowlistApplicationsView from "@/systems/modules/allowlist/AllowlistApplicationsView.vue";
import AllowlistApplicationQuestionsView from "@/systems/modules/allowlist/AllowlistApplicationQuestionsView.vue";
import authorization from "@/authorization";
import AllowlistHeaderView from "@/systems/modules/allowlist/AllowlistHeaderView.vue";
import AllowlistView from "@/systems/modules/allowlist/AllowlistView.vue";
import {RouterView} from "vue-router";
import settings from "@/systems/modules/settings/settings";
import {modules} from "@/systems/modules/modules";

export default {
    getRoutes: () => ([
        {
            name: "community.modules.allowlist",
            path: "allowlist",
            component: AllowlistHeaderView,
            meta: {
                authorize: () => authorization.moduleEnabled("allowlist") && (authorization.permission("modules.allowlist.entries.edit") || authorization.permission("modules.allowlist.applications.answer") || authorization.permission("modules.allowlist.applications.questions.edit")),
            },
            redirect: () => authorization.permission("modules.allowlist.entries.edit") ? ({ name: "community.modules.allowlist.list" }) : authorization.permission("modules.allowlist.applications.answer") ? ({ name: "community.modules.allowlist.applications" }) : authorization.permission("modules.allowlist.applications.questions.edit") ? ({ name: "community.allowlist.applications.questions" }) : "/",
            children: [
                {
                    name: "community.modules.allowlist.list",
                    path: "list",
                    component: AllowlistEntriesView,
                    props: route => ({ communityId: route.params.communityId }),
                    meta: {
                        authorize: () => authorization.permission("modules.allowlist.entries.edit")
                    }
                },
                {
                    name: "community.modules.allowlist.applications",
                    path: "applications",
                    component: AllowlistApplicationsView,
                    props: route => ({ communityId: route.params.communityId }),
                    meta: {
                        authorize: () => authorization.permission("modules.allowlist.applications.answer")
                    }
                },
                {
                    name: "community.modules.allowlist.applications.questions",
                    path: "applications/questions",
                    component: AllowlistApplicationQuestionsView,
                    props: route => ({ communityId: route.params.communityId }),
                    meta: {
                        authorize: () => authorization.permission("modules.allowlist.applications.questions.edit")
                    }
                },
                ...settings.getRoutes(modules.allowlist)
            ]
        }
    ]),
    getPlayerRoutes: () => ([
        {
            name: "player.modules.allowlist",
            path: "allowlist",
            component: RouterView,
            props: true,
            meta: {
                authorize: () => authorization.moduleEnabled("allowlist") && authorization.permission("modules.allowlist.applications.answer")
            },
            redirect: { name: "player.modules.allowlist.home" },
            children: [
                {
                    name: "player.modules.allowlist.home",
                    path: "",
                    component: AllowlistView,
                    props: true
                },
                {
                    name: "player.modules.allowlist.applications",
                    path: "applications",
                    component: AllowlistApplicationsView,
                    props: true
                }
            ]
        },
        // {
        //     name: "community.modules.allowlist.player",
        //     path: "allowlist",
        //     component: RouterView,
        //     props: true,
        //     meta: {
        //         title: "allowlist",
        //         icon: "fas fa-list text-info",
        //         authorize: () => authorization.moduleEnabled("allowlist") && authorization.permission("community.players.view"),
        //     },
        //     redirect: { name: "community.modules.allowlist.player.home" },
        //     children: [
        //         {
        //             name: "community.modules.allowlist.player.home",
        //             path: "home",
        //             component: AllowlistPlayerHomePage,
        //             props: true,
        //             meta: {
        //                 title: "home",
        //                 icon: "fas fa-home text-primary"
        //             }
        //         },
        //         {
        //             name: "community.modules.allowlist.player.applications.list",
        //             path: "applications",
        //             component: PageAllowlistApplications,
        //             props: true,
        //             meta: {
        //                 title: "applications",
        //                 icon: "fas fa-file-contract text-warning",
        //                 authorize: () => authorization.permission("modules.allowlist.applications.answer")
        //             }
        //         }
        //     ]
        // },
    ])
};